import gql from 'graphql-tag';

const GET_CAMPAIGN_ORDER_TAG_ACTIVITIES = gql`
  query campaignOrderTagsActivities($id: ID!, $orgId: ID!) {
    campaignOrderTagsActivities(id: $id, orgId: $orgId)
  }
`;

export default GET_CAMPAIGN_ORDER_TAG_ACTIVITIES;
